const CENTRAL_TIMEZONE = 'America/Chicago';

const parseDateParts = (value) => {
  const [year, month, day] = String(value || '')
    .trim()
    .split('-')
    .map((part) => Number(part));
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return null;
  return { year, month, day };
};

const getTimeZoneOffsetMinutes = (date, timeZone) => {
  const safeDate = new Date(Math.floor(date.getTime() / 1000) * 1000);
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
  const parts = formatter.formatToParts(safeDate);
  const values = parts.reduce((acc, part) => {
    if (part.type !== 'literal') acc[part.type] = part.value;
    return acc;
  }, {});
  const asUtc = Date.UTC(
    Number(values.year),
    Number(values.month) - 1,
    Number(values.day),
    Number(values.hour),
    Number(values.minute),
    Number(values.second)
  );
  return (asUtc - safeDate.getTime()) / 60000;
};

const zonedTimeToUtc = (dateString, timeZone, timeParts) => {
  const parts = parseDateParts(dateString);
  if (!parts) return null;
  const { year, month, day } = parts;
  const {
    hours = 0,
    minutes = 0,
    seconds = 0,
    ms = 0,
  } = timeParts || {};
  const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds, ms));
  const offsetMinutes = getTimeZoneOffsetMinutes(utcDate, timeZone);
  return new Date(utcDate.getTime() - offsetMinutes * 60000);
};

export const buildCentralDayRange = (startDate, endDate) => {
  const start = startDate
    ? zonedTimeToUtc(startDate, CENTRAL_TIMEZONE, { hours: 0, minutes: 0, seconds: 0, ms: 0 })
    : null;
  const end = endDate
    ? zonedTimeToUtc(endDate, CENTRAL_TIMEZONE, { hours: 23, minutes: 59, seconds: 59, ms: 999 })
    : null;
  return {
    start: start ? start.toISOString() : null,
    end: end ? end.toISOString() : null,
  };
};

export { CENTRAL_TIMEZONE };
